import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import Dashboard from "./pages/Dashboard/Dashboard";
import UserManagement from "./pages/UserManagement/UserManagement";
import OrderOverview from "./pages/OrderOverview/OrderOverview";
import UmbrellaContainers from "./pages/UmbrellaContainers/UmbrellaContainers";
import ShipmentRates from "./pages/ShipmentRates/ShipmentRates";
import PackageEnquiry from "./pages/PackageEnquiry/PackageEnquiry";
import WareHouseManagement from "./pages/WareHouseManagement/WareHouseManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import CountryUserManagement from "./pages/CountryUserManagement/CountryUserManagement";
import Support from "./pages/Support/Support";
import SupportMessage from "./pages/Support/SupportMessage";
import SupportComponent from "./pages/Support/SupportComponent";
import MarketingNotifications from "./pages/MarketingNotifications/MarketingNotifications";
import WeProcure from "./pages/WeProcure/WeProcure";
import WeQa from "./pages/WeQa/WeQa";
import ContentUserManagement from "./pages/ContentUserManagement/ContentUserManagement";
import PublicRoute from "./components/PublicRoute";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
function App() {
  const localData = JSON.parse(localStorage.getItem("mastercreds"));
  const ForceRedirect = ({ to }) => {
    useEffect(() => {
      window.location.replace(to); // full page reload
    }, [to]);
    
    return null;
  };
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />
        <Route>
          <Route
            exact
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/country-users"
            element={
              <ProtectedRoute>
                <CountryUserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/content-admin"
            element={
              <ProtectedRoute>
                <ContentUserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/orders"
            element={
              <ProtectedRoute>
                <OrderOverview />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/umbrella-management"
            element={
              <ProtectedRoute>
                <UmbrellaContainers />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/shipment-charges"
            element={
              <ProtectedRoute>
                <ShipmentRates />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/shipment-enquiry"
            element={
              <ProtectedRoute>
                <PackageEnquiry />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/warehouse"
            element={
              <ProtectedRoute>
                <WareHouseManagement />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/support"
            element={
              <ProtectedRoute>
                <SupportComponent masterData={localData} />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/we-procure"
            element={
              <ProtectedRoute>
                <WeProcure />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/we-qa"
            element={
              <ProtectedRoute>
                <WeQa />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/support-message"
            element={
              <ProtectedRoute>
                <SupportMessage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/marketing-notifications"
            element={
              <ProtectedRoute>
                <MarketingNotifications />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          exact
          path="/index-2"
          element={
            <ProtectedRoute>
              <HomePageTwo />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-3"
          element={
            <ProtectedRoute>
              <HomePageThree />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-4"
          element={
            <ProtectedRoute>
              <HomePageFour />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-5"
          element={
            <ProtectedRoute>
              <HomePageFive />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-6"
          element={
            <ProtectedRoute>
              <HomePageSix />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-7"
          element={
            <ProtectedRoute>
              <HomePageSeven />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-8"
          element={
            <ProtectedRoute>
              <HomePageEight />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-9"
          element={
            <ProtectedRoute>
              <HomePageNine />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-10"
          element={
            <ProtectedRoute>
              <HomePageTen />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/index-11"
          element={
            <ProtectedRoute>
              <HomePageEleven />
            </ProtectedRoute>
          }
        />

        {/* SL */}
        <Route
          exact
          path="/add-user"
          element={
            <ProtectedRoute>
              <AddUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/alert"
          element={
            <ProtectedRoute>
              <AlertPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/assign-role"
          element={
            <ProtectedRoute>
              <AssignRolePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/avatar"
          element={
            <ProtectedRoute>
              <AvatarPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/badges"
          element={
            <ProtectedRoute>
              <BadgesPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/button"
          element={
            <ProtectedRoute>
              <ButtonPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/calendar-main"
          element={
            <ProtectedRoute>
              <CalendarMainPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/calendar"
          element={
            <ProtectedRoute>
              <CalendarMainPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/card"
          element={
            <ProtectedRoute>
              <CardPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/carousel"
          element={
            <ProtectedRoute>
              <CarouselPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-empty"
          element={
            <ProtectedRoute>
              <ChatEmptyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-message"
          element={
            <ProtectedRoute>
              <ChatMessagePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/chat-profile"
          element={
            <ProtectedRoute>
              <ChatProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/code-generator"
          element={
            <ProtectedRoute>
              <CodeGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/code-generator-new"
          element={
            <ProtectedRoute>
              <CodeGeneratorNewPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/colors"
          element={
            <ProtectedRoute>
              <ColorsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/column-chart"
          element={
            <ProtectedRoute>
              <ColumnChartPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/company"
          element={
            <ProtectedRoute>
              <CompanyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/currencies"
          element={
            <ProtectedRoute>
              <CurrenciesPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/dropdown"
          element={
            <ProtectedRoute>
              <DropdownPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/email"
          element={
            <ProtectedRoute>
              <EmailPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/faq"
          element={
            <ProtectedRoute>
              <FaqPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/forgot-password"
          element={
            <ProtectedRoute>
              <ForgotPasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form-layout"
          element={
            <ProtectedRoute>
              <FormLayoutPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form-validation"
          element={
            <ProtectedRoute>
              <FormValidationPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/form"
          element={
            <ProtectedRoute>
              <FormPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/gallery"
          element={
            <ProtectedRoute>
              <GalleryPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-grid"
          element={
            <ProtectedRoute>
              <GalleryGridPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-masonry"
          element={
            <ProtectedRoute>
              <GalleryMasonryPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/gallery-hover"
          element={
            <ProtectedRoute>
              <GalleryHoverPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/blog"
          element={
            <ProtectedRoute>
              <BlogPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/blog-details"
          element={
            <ProtectedRoute>
              <BlogDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/add-blog"
          element={
            <ProtectedRoute>
              <AddBlogPage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/testimonials"
          element={
            <ProtectedRoute>
              <TestimonialsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/coming-soon"
          element={
            <ProtectedRoute>
              <ComingSoonPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/access-denied"
          element={
            <ProtectedRoute>
              <AccessDeniedPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/maintenance"
          element={
            <ProtectedRoute>
              <MaintenancePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/blank-page"
          element={
            <ProtectedRoute>
              <BlankPagePage />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/image-generator"
          element={
            <ProtectedRoute>
              <ImageGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/image-upload"
          element={
            <ProtectedRoute>
              <ImageUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-add"
          element={
            <ProtectedRoute>
              <InvoiceAddPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-edit"
          element={
            <ProtectedRoute>
              <InvoiceEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-list"
          element={
            <ProtectedRoute>
              <InvoiceListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/invoice-preview"
          element={
            <ProtectedRoute>
              <InvoicePreviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/kanban"
          element={
            <ProtectedRoute>
              <KanbanPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/language"
          element={
            <ProtectedRoute>
              <LanguagePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/line-chart"
          element={
            <ProtectedRoute>
              <LineChartPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/list"
          element={
            <ProtectedRoute>
              <ListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/marketplace-details"
          element={
            <ProtectedRoute>
              <MarketplaceDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/marketplace"
          element={
            <ProtectedRoute>
              <MarketplacePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/notification-alert"
          element={
            <ProtectedRoute>
              <NotificationAlertPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/notification"
          element={
            <ProtectedRoute>
              <NotificationPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/pagination"
          element={
            <ProtectedRoute>
              <PaginationPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/payment-gateway"
          element={
            <ProtectedRoute>
              <PaymentGatewayPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/pie-chart"
          element={
            <ProtectedRoute>
              <PieChartPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/portfolio"
          element={
            <ProtectedRoute>
              <PortfolioPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/pricing"
          element={
            <ProtectedRoute>
              <PricingPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/progress"
          element={
            <ProtectedRoute>
              <ProgressPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/radio"
          element={
            <ProtectedRoute>
              <RadioPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/role-access"
          element={
            <ProtectedRoute>
              <RoleAccessPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/sign-up"
          element={
            <ProtectedRoute>
              <SignUpPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/star-rating"
          element={
            <ProtectedRoute>
              <StarRatingPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/starred"
          element={
            <ProtectedRoute>
              <StarredPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/switch"
          element={
            <ProtectedRoute>
              <SwitchPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/table-basic"
          element={
            <ProtectedRoute>
              <TableBasicPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/table-data"
          element={
            <ProtectedRoute>
              <TableDataPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/tabs"
          element={
            <ProtectedRoute>
              <TabsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/tags"
          element={
            <ProtectedRoute>
              <TagsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/terms-condition"
          element={
            <ProtectedRoute>
              <TermsConditionPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/text-generator-new"
          element={
            <ProtectedRoute>
              <TextGeneratorNewPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/text-generator"
          element={
            <ProtectedRoute>
              <TextGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/theme"
          element={
            <ProtectedRoute>
              <ThemePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/tooltip"
          element={
            <ProtectedRoute>
              <TooltipPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/typography"
          element={
            <ProtectedRoute>
              <TypographyPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/users-grid"
          element={
            <ProtectedRoute>
              <UsersGridPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/users-list"
          element={
            <ProtectedRoute>
              <UsersListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/view-details"
          element={
            <ProtectedRoute>
              <ViewDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/video-generator"
          element={
            <ProtectedRoute>
              <VideoGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/videos"
          element={
            <ProtectedRoute>
              <VideosPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/view-profile"
          element={
            <ProtectedRoute>
              <ViewProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/voice-generator"
          element={
            <ProtectedRoute>
              <VoiceGeneratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/wallet"
          element={
            <ProtectedRoute>
              <WalletPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/widgets"
          element={
            <ProtectedRoute>
              <WidgetsPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/wizard"
          element={
            <ProtectedRoute>
              <WizardPage />
            </ProtectedRoute>
          }
        />

        {/* <Route exact path="*" element={<ErrorPage />} /> */}
        <Route
          path="*"
          element={
            localStorage.getItem("accessToken") ? (
              <ForceRedirect to="/dashboard" replace />
            ) : (
              <ForceRedirect to="/" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
